import { useChatTransport as e } from "../transport/ChatTransportContext.mjs";
import { useInfiniteList as t, useInfiniteQuery as n } from "@maat/store-hooks";
//#region src/hooks/useMessagesQuery.ts
var r = 50, i = (i) => {
	let { api: a, keys: o } = e();
	return t(n({
		queryKey: o.messages(i),
		queryFn: async ({ pageParam: e }) => a.getMessages(i, {
			limit: r,
			offset: e
		}),
		initialPageParam: 0,
		getNextPageParam: (e, t) => e.hasMore ? t.reduce((e, t) => e + t.messages.length, 0) : void 0,
		enabled: !!i
	}), "messages");
};
//#endregion
export { i as useMessagesQuery };
